<template>
  <div id="LandingSurveyClient" class="row">
    <div class="overlay"></div>

    <div class="modal SurveyClient">
      <div style="display: flex; margin-bottom: 25px;">
        <img
          src="/btk/btk_logo.png"
          style="width: 40px; margin-right: 15px;"
          alt=""
        />
        <span class="SurveyClient"
          >{{ $t("WelcomeTo") }} {{ organizationName }}
        </span>
      </div>

      <div
        v-if="
          surveys[stepInvestigation] &&
            surveys[stepInvestigation].questions[stepQuestion]
        "
        class="group"
      >
        <b>{{ surveys[stepInvestigation].questions[stepQuestion].question }}</b>
      </div>

      <div
        v-if="
          surveys[stepInvestigation] &&
            surveys[stepInvestigation].questions[stepQuestion]
        "
        style="display: flex;"
      >
        <div
          v-for="(itemA, index) in surveys[stepInvestigation].questions[
            stepQuestion
          ].answers"
          :key="index"
          class="footer"
        >
          <button class="btn" @click="submitSurvey(itemA)">
            {{ itemA.answer }}
          </button>
        </div>
        <!-- <button class="btn" style="background-color: #fff; border-color: var(--primary); color: var(--primary);">
          {{ "Non" }}
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { investigationsService } from "../../_services";
var Config = require("@config");

export default {
  data: () => ({
    lang: localStorage.getItem("Language"),
    loading: false,
    terms: false,
    error_edit: false,
    checkTerms: false,
    checkName: false,
    checkEmail: false,
    organizationName: "",
    organizationId: "",
    surveys: [],
    stepInvestigation: 0,
    stepQuestion: 0,
    selectedAnswers: [],
  }),
  props: {
    user: Object,
  },
  mounted() {
    if (this.lang == "ar") {
      document.getElementById("termsNcond").dir = "rtl";
    }
    this.organizationName = Config.organization_name;
    this.organizationId = Config.organization_id;
  },
  methods: {
    submitSurvey(answer) {
      let obj = [];
      obj.push(this.organizationId);
      obj.push(answer.question_id);
      obj.push(answer.id);
      this.selectedAnswers.push(obj.join());
      if (
        this.stepQuestion !=
        this.surveys[this.stepInvestigation].questions.length - 1
      ) {
        this.stepQuestion++;
        return 0;
      }
      // if(this.stepInvestigation != (this.surveys.length - 1)) {
      //   this.stepInvestigation ++;
      //   return 0;
      // }
      this.loading = true;
      let payload = new FormData();
      for (var i = 0; i < this.selectedAnswers.length; i++) {
        payload.append("results[" + i + "]", this.selectedAnswers[i]);
      }

      payload.append(
        "investigation_id",
        this.surveys[this.stepInvestigation].id
      );
      payload.append("_method", "POST");
      investigationsService
        .submitInvestigation(payload)
        .then(function(res) {
          this.hide();
          this.$emit("checkFeedback");
        }.bind(this))
        .catch(
          function(err) {
            console.log(err);
          }.bind(this)
        )
        .finally(
          function() {
            this.loading = false;
          }.bind(this)
        );
    },
    show(surveys) {
      $("#LandingSurveyClient").fadeIn("300");
      this.surveys = surveys.filter((el) => el.status == 1);
      // this.surveys = surveys;
    },
    hide() {
      $("#LandingSurveyClient").fadeOut("300", function() {
        $(".SurveyClient").fadeIn();
        $(".RegisterModal").fadeOut();
        $(".VerifyModal").fadeOut();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.SurveyClient {
  font-size: 18px;
  font-weight: 900;
  width: 100%;
  display: flex;
  margin: auto;
  justify-content: center;
  color: var(--primary);
}
#LandingSurveyClient {
  width: 100vw;
  height: 100vh;
  min-height: -webkit-fill-available;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  position: absolute;
  top: 50%;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999990;

  display: none;
  .overlay {
    width: 100vw;
    height: 100vh;
    min-height: -webkit-fill-available;
    z-index: 9999999999991;
    cursor: pointer;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .modal {
    width: 35%;
    height: auto;
    min-width: 320px;
    background: #fff;
    z-index: 992;
    border-radius: 25px;
    padding: 25px 50px;

    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .Verify {
      margin-top: 20px;
      .code {
        display: flex;
        justify-content: center;
        input {
          margin-left: 10px;
          margin-right: 10px;
          height: 50px;
          width: 50px;
          border: 1px solid var(--primary);
          color: var(--primary);
          border-radius: 5px;
          text-align: center;
          font-size: 15px;
        }
      }
    }
    .group {
      b {
        font-size: 13px;
        font-size: 900;
        margin-bottom: 10px;
        display: block;
        color: #111111;
      }
      input {
        width: 100%;
        height: 40px;
        padding: 0 20px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
    .footer {
      text-align: center;
      margin: 5px auto;
      .text {
        color: #555;
        font-size: 14px;
      }
      button {
        background: var(--primary);
        color: var(--primary-font);
        padding: 10px 25px;
        border-radius: 100px;
        letter-spacing: 1px;
        margin: 5px 10px;
        font-size: 13px;
        white-space: nowrap;
      }
      button:hover {
        background: var(--primary-hover);
      }
    }
  }
  .RegisterModal {
    display: none;
  }
  @media only screen and (max-width: 800px) {
    .modal {
      padding: 20px 25px;
      .Verify {
        .code {
          input {
            width: 40px;
            height: 40px;
            margin-left: 5px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>
